export default __webpack_public_path__ + "static/media/aws2020practice01-aws-s3-ec2-services-v02.3942935a.pdf";